import { Stack } from '@mui/material';
import { SuspenseWithSentryErrorBoundary } from '@retail/components';
import {
  PriceRoundingBrandContainer,
  PriceRoundingMemberContainer,
} from '@retail/rounding/containers';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';

export function PriceRoundingPage() {
  const { isBrandContext } = useSelectedOrgUnit();

  return (
    <Stack flexGrow={1} pb={2} overflow="hidden">
      <SuspenseWithSentryErrorBoundary>
        {isBrandContext ? <PriceRoundingBrandContainer /> : <PriceRoundingMemberContainer />}
      </SuspenseWithSentryErrorBoundary>
    </Stack>
  );
}
